import { declOfNum } from '../../../../helpers/common';
export var getLabelTextDefault = function (count, size) {
    var text = "\u0412\u044B\u0431\u0440\u0430\u043D\u043E: " + count;
    var extended = size !== 'small' ? declOfNum(count, ['значение', 'значения', 'значений']) : '';
    if (extended) {
        text += " " + extended;
    }
    return text;
};
//# sourceMappingURL=helpers.js.map